module.exports = __webpack_public_path__ + "static/img/峰岭科技LOGO.34cd292f.png";